export enum LegalConsentType {
    CommunicationConsent,
    ProcessingConsent,
}

export interface ILegalConsentItem {
    enteredValue: string;
    id: number;
    isCheckBoxHidden: boolean;
    isCheckBoxRequired: boolean;
    label: string;
    legalConsentType: LegalConsentType;
}
